export const FontFamily = 'Plus Jakarta Sans, Helvetica, Arial, sans-serif';

type Typography = {
  FontFamily: string;
  FontSize: number;
  FontWeight: FontWeight;
  LineHeight: number;
};

function getFontDefinition(
  fontWeight: FontWeight,
  fontSize: number,
  lineHeight: number
): Typography {
  return {
    FontFamily: FontFamily,
    FontSize: fontSize,
    FontWeight: fontWeight,
    LineHeight: lineHeight,
  };
}

export enum FontWeight {
  Thin = 100,
  ExtraLight = 200,
  Light = 300,
  Regular = 400,
  Medium = 500,
  SemiBold = 600,
  Bold = 700,
  ExtraBold = 800,
  Heavy = 900,
}

export const Size = {
  HugeTitleBold: getFontDefinition(FontWeight.Bold, 64, 78),
  HugeTitle: getFontDefinition(FontWeight.Bold, 48, 58),
  LargeTitle: getFontDefinition(FontWeight.Bold, 38, 46),
  DisplayLarge: getFontDefinition(FontWeight.Bold, 30, 38),
  DisplayMedium: getFontDefinition(FontWeight.Bold, 28, 32),
  DisplaySmall: getFontDefinition(FontWeight.Bold, 24, 30),
  Heading: getFontDefinition(FontWeight.SemiBold, 20, 30),
  SubHeading: getFontDefinition(FontWeight.Medium, 20, 26),
  BodyLargeHeavy: getFontDefinition(FontWeight.Bold, 16, 20),
  BodyLarge: getFontDefinition(FontWeight.SemiBold, 16, 20),
  BodyHeavy: getFontDefinition(FontWeight.SemiBold, 14, 18),
  Body: getFontDefinition(FontWeight.Medium, 14, 22),
  SmallHeavy: getFontDefinition(FontWeight.SemiBold, 12, 16),
  Small: getFontDefinition(FontWeight.Medium, 12, 16),
  Badge: getFontDefinition(FontWeight.Medium, 8, 12),
};

export type FontSize = keyof typeof Size;
